export default (name: string) => {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
    const results = regex.exec(window.location.href);
    return results === null
        ? ""
        : decodeURIComponent(results[1].replace(/\+/g, " "));
}
